module.exports = __webpack_public_path__ + "img/143.8.b5050b12.png";